import { render, staticRenderFns } from "./businessDistrict.vue?vue&type=template&id=5fcce3b4&"
import script from "./businessDistrict.vue?vue&type=script&lang=js&"
export * from "./businessDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports